import React from "react";
import * as Styled from "./LeaseCashLoanSection.styled";
import LeaseCashLoanImage from "../../../images/bg/lease-cash-loan.gif";

function LeaseCashLoanSection() {
  return (
    <Styled.MaxWidth>
      <Styled.MainWrapper>
        <Styled.ImageWrapper>
          <Styled.LeaseCashLoanImg
            src={LeaseCashLoanImage}
            alt="lease vs cash vs loan"
          />
        </Styled.ImageWrapper>
        <Styled.ContentWrapper>
          <Styled.Title>
            Huge extra EV savings
          </Styled.Title>
          <Styled.Content>
            You can now buy and run an <a href="https://www.novatedleaseaustralia.com.au/electric-cars" target="_blank" rel="noreferrer">eligible electric vehicle</a> (up to the luxury car tax threshold) 
            through a novated lease and be exempt from <a href="https://www.novatedleaseaustralia.com.au/electric-cars/exempt-from-FBT" target="_blank" rel="noreferrer">fringe benefits tax (FBT)</a>.
            This supersizes the already considerable savings.
            The example calculations assume a 5-year lease/finance term, a driver based in NSW with 
            an annual pre-tax salary of $100,000, a car loan interest rate of 7.2% p.a, car running costs 
            based on 15,000km driven per year. Car running costs include electricity, rego/CTP, insurance, servicing and tyres.
          </Styled.Content>
        </Styled.ContentWrapper>
      </Styled.MainWrapper>
    </Styled.MaxWidth>
  );
}

export default LeaseCashLoanSection;
